exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-primary[data-v-a5ce89e0] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-a5ce89e0] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a5ce89e0","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/user-administration/UserAdministration.vue
// module id = 689
// module chunks = 1